import React from 'react';
import Button from '@atlaskit/button';
import { useIntl, type MessageDescriptor } from '@atlassian/jira-intl/src/index.tsx';

type Props = {
	baseUrl: string;
	projectKey: string;
	settingMessage: MessageDescriptor;
};

export const LinkToConfluenceSetting = ({ baseUrl, projectKey, settingMessage }: Props) => {
	const intl = useIntl();
	return (
		<p>
			<Button appearance="link" href={`${baseUrl}/${projectKey}/confluence-kb`} spacing="none">
				{intl.formatMessage(settingMessage)}
			</Button>
		</p>
	);
};
